import { render, staticRenderFns } from "./BranchQR.vue?vue&type=template&id=508e471a&scoped=true&"
import script from "./BranchQR.vue?vue&type=script&lang=ts&"
export * from "./BranchQR.vue?vue&type=script&lang=ts&"
import style0 from "./BranchQR.vue?vue&type=style&index=0&id=508e471a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508e471a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
